import axios from 'axios';
import authService from './authService';
import { API_URL } from '@/config/api';

const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
});

// Interceptor para adicionar token em todas as requisições
api.interceptors.request.use(
  (config) => {
    const token = authService.token.get();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratamento de erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      authService.logout();
    }
    return Promise.reject(error);
  }
);

export default {
  /**
   * Listar itens ativos da loja
   */
  getItens() {
    return api.get('/loja/itens');
  },

  /**
   * Listar itens por categoria
   * @param {string} categoria - COMIDA, BEBIDA, PRESENTE, RECOMPENSA, OUTRO
   */
  getItensPorCategoria(categoria) {
    return api.get(`/loja/itens/categoria/${categoria}`);
  },

  /**
   * Buscar item por ID
   * @param {number} id - ID do item
   */
  getItemPorId(id) {
    return api.get(`/loja/itens/${id}`);
  },

  /**
   * Comprar item
   * @param {object} dados - { itemLojaId, observacao }
   */
  comprarItem(dados) {
    return api.post('/loja/comprar', dados);
  },

  /**
   * Listar todas as compras
   */
  getCompras() {
    return api.get('/loja/compras');
  },

  /**
   * Listar compras pendentes
   */
  getComprasPendentes() {
    return api.get('/loja/compras/pendentes');
  },

  /**
   * Listar compras por status
   * @param {string} status - PENDENTE, RESGATADA, CANCELADA
   */
  getComprasPorStatus(status) {
    return api.get(`/loja/compras/status/${status}`);
  },

  /**
   * Buscar compra por ID
   * @param {number} id - ID da compra
   */
  getCompraPorId(id) {
    return api.get(`/loja/compras/${id}`);
  },

  /**
   * Marcar compra como resgatada
   * @param {number} id - ID da compra
   */
  resgatarCompra(id) {
    return api.patch(`/loja/compras/${id}/resgatar`);
  },

  /**
   * Cancelar compra (estorna coins)
   * @param {number} id - ID da compra
   */
  cancelarCompra(id) {
    return api.delete(`/loja/compras/${id}`);
  }
};

